import CanalFacts from './canal-facts';
import CanalFact from './canal-fact';

export {
    CanalFact,
    CanalFacts
};